import { useState, useContext, useEffect } from "react";
import { Badge, Button, Fade, Stack } from "@mui/material";
import styles from "../../content/pages/homepage.module.css";
import { WidgetContext } from "src/contexts/WidgetContext";
import { Box } from "@mui/system";
import NewsResponse from "./NewsResponse";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Drawer from "@mui/material/Drawer";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import { isIOS, isAndroid } from "../../utils/platformUtils";
import { trackFeatureTimeSpent } from "src/utils/analyticsCapFirebase";
import { useAuth0 } from "@auth0/auth0-react";

function NewsPartnerList({ onClose, newsData, loadingNews }) {
  const { user } = useAuth0();
  const { isDrawerOpen, selectedPartner, setIsDrawerOpen, setSelectedPartner, selectedTeamInfo, NON_LOGGED_IN_CONFIG, aiSettings } = useContext(WidgetContext);

  // Track when drawer opens
  const [drawerOpenTime, setDrawerOpenTime] = useState<number | null>(null);

  // Track drawer open time
  useEffect(() => {
    if (isDrawerOpen && !drawerOpenTime) {
      setDrawerOpenTime(Date.now());
    }
  }, [isDrawerOpen, drawerOpenTime]);

  const handleClose = () => {
    // Calculate time spent if drawer was open
    if (drawerOpenTime) {
      const timeSpentMs = Date.now() - drawerOpenTime;
      const timeSpentSeconds = Math.round(timeSpentMs / 1000);

      // Get current platform/team info from context
      const currentPlatform = selectedTeamInfo?.platformId || "unknown";
      const authId = user?.sub ?? NON_LOGGED_IN_CONFIG.authId ?? "unknown";

      console.log("currentPlatform NEWS", currentPlatform);
      console.log("timeSpentSeconds NEWS", timeSpentSeconds, "seconds");

      // Track the time spent
      if (timeSpentSeconds > 0) {
        trackFeatureTimeSpent(authId, "news", timeSpentSeconds, currentPlatform);
      }

      // Reset timer
      setDrawerOpenTime(null);
    }

    // Sync close: onClose clears thoughts + closes drawer (avoids sign flash before clear)
    onClose();
  };

  return (
    <>
      <Drawer
        anchor="bottom"
        open={isDrawerOpen}
        // onClose={handleClose}
        // onOpen={() => setIsDrawerOpen(true)}
        hideBackdrop={true}
        sx={{
          pointerEvents: "none", // Add this - makes the entire drawer container non-interactive
        }}
        ModalProps={{
          sx: {
            pointerEvents: "auto", // Block background scroll when drawer is open
            zIndex: 1450,
          },
        }}
        PaperProps={{
          sx: {
            width: {
              xs: "100%",
              sm: "720px",
              md: "720px",
              lg: "720px",
            },
            margin: {
              xs: "0",
              sm: "0 auto",
              md: "0 auto",
              lg: "0 auto",
            },
            // height: isIOS || isAndroid ? "calc(100svh - env(safe-area-inset-top) - 56px)" : "calc(100vh  - 56px)",
            height: isIOS || isAndroid
              ? (aiSettings.quan ? "calc(100svh - env(safe-area-inset-top))" : "calc(100svh - env(safe-area-inset-top) - 56px)")
              : (!aiSettings.quan ? "calc(100vh - 56px)" : "100%"), border: `1px solid ${PureLightThemeCaaS.colors.alpha.white[30]}`,
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
          },
        }}
      >
        <Fade in={isDrawerOpen} timeout={700}>
          <Box
            className={styles.noScrollbar}
            sx={{
              bgcolor: `${PureLightThemeCaaS.colors.alpha.black[100]}`,
              height: "100%",
              overflow: "hidden",
              position: "relative",
              touchAction: "none", //Prevent scroll of the parent container
              "& > *": {
                touchAction: "pan-y", //Allow scroll only in child components
              },
              // ADD THIS LINE to respect the bottom safe area on all devices
              paddingBottom: isAndroid ? "max(env(safe-area-inset-bottom), 15px)" : "0px",
              pointerEvents: "auto", // Add this - re-enables interaction inside the drawer
            }}
          >
            {selectedPartner && <NewsResponse onClose={handleClose} newsData={newsData} loadingNews={loadingNews} />}
          </Box>
        </Fade>
      </Drawer>
    </>
  );
}

export default NewsPartnerList;
